import styled from '@emotion/styled';
import { Colors } from '@dizraptors/ui-kit';

export const Container = styled('div')`
  padding: 6rem 2rem 8.6rem;
  margin: auto 0;
  text-align: center;
  background-color: ${Colors.ut.bgDefault};
`;

export const CactusImage = styled('img')`
  vertical-align: top;
  width: 11rem;
  height: 21.5rem;
  margin-bottom: 2.5rem;
`;

export const CodeError = styled('p')`
  display: inline-block;
  vertical-align: top;
  margin-top: 0.6rem;
  padding: 0.3rem 1.1rem 0.2rem;
  color: ${Colors.text.inverse};
  background-color: ${Colors.text.default};
  border-radius: 0.3rem;
`;
